module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03-m-en.81767e73ff56f271d8948289c4fa0dc7.png";